export const createClientSiteCoreKeys = {
  createClientHeader:
    "ClientManagement.CreateClientComponent.CreateClientHeader",
  createClientProfileTitle:
    "ClientManagement.CreateClientComponent.CreateClientProfile",
  clientMailingAddressTitle:
    "ClientManagement.CreateClientComponent.ClientMailingAddress",
  individualMailingAddressSectionHeading:
    "ClientManagement.ClientMailingAddress.IndividualMailingAddressSectionHeading",
  clientTypeList: "ClientManagement.CreateClientProfile.ClientTypeList",
  address: "ClientManagement.ClientMailingAddress.Address",
  address1: "ClientManagement.ClientMailingAddress.Address1",
  address2: "ClientManagement.ClientMailingAddress.Address2",
  address3: "ClientManagement.ClientMailingAddress.Address3",
  country: "ClientManagement.ClientMailingAddress.Country",
  city: "ClientManagement.ClientMailingAddress.City",
  stateProvince: "ClientManagement.ClientMailingAddress.StateProvince",
  stateRegionProvinceListPrefix:
    "ClientManagement.ClientMailingAddress.StateRegionProvinceList",
  postalCode: "ClientManagement.ClientMailingAddress.PostalCode",
  waitClientCreatingMessage:
    "ClientManagement.ClientMailingAddress.WaitClientCreatingMessage",
  contactsLoadingMessage:
    "ClientManagement.ClientMailingAddress.ContactsLoadingMessage",
  clientCreatedMessage:
    "ClientManagement.ClientMailingAddress.ClientCreatedMessage",

  searchClientTitle: "ClientManagement.SearchClientComponent.SearchClient",
  searchParentClient: "ClientManagement.SearchClient.SearchParentClientHeading",
  pleaseSelectAParentClientToProceed:
    "ClientManagement.SearchClient.PleaseSelectAParentClientToProceed",

  addContact: "ClientManagement.Contacts.AddContact",
  contactName: "ClientManagement.Contacts.ContactName",
  usedByClient: "ClientManagement.Contacts.UsedByClient",
  contactType: "ClientManagement.Contacts.ContactType",
  surveyContact: "ClientManagement.Contacts.SurveyContact",
  status: "ClientManagement.Contacts.Status",
  contactNo: "ClientManagement.Contacts.ContactNo",
  modifiedOn: "ClientManagement.Contacts.ModifiedOn",
  action: "ClientManagement.Contacts.Action",
  clientCreated: "ClientManagement.Contacts.ClientCreated",
  noRecordsAvailable: "ClientManagement.Contacts.NoRecordsAvailable",
  surveyContactList: "ClientManagement.Contacts.ContactSurvey",
  contactStatusList: "ClientManagement.Contacts.Status",
  contactDeleted: "ClientManagement.Contacts.ContactDeleted",
  deleteContactActionText: "ClientManagement.Contacts.DeleteContactActionText",
  deletingBillingOrHRContactMessage:
    "ClientManagement.Contacts.DeletingBillingOrHRContactMessage",
  retainAtleastOneContactMessage:
    "ClientManagement.Contacts.AtleastOneContactRetainMessage",
  contactsMeetOneContactRequirements:
    "ClientManagement.Contacts.WarningToProceedYouNeedToMeetOneOfTheFollowingContactRequirements",
  cannotRemoveThisContactCurrentlyUsed:
    "ClientManagement.Contacts.WarningYouCannotRemoveThisContactAsItIsCurrentlyUsed",
  createContactToProceed:
    "ClientManagement.Contacts.WarningYouNeedToMeetAtLeastOneOfTheFollowingContactRequirements",
  contactTypeShouldNotBeDeletedMessage:
    "ClientManagement.Contacts.ContactTypeShouldNotBeDeletedMessage",

  companyName: "ClientManagement.CreateClientProfile.CompanyName",
  englishCompanyName: "ClientManagement.CreateClientProfile.EnglishCompanyName",
  clientType: "ClientManagement.CreateClientProfile.ClientType",
  industry: "ClientManagement.CreateClientProfile.Industry",

  addressCountry: "ClientManagement.CreateClientProfile.AddressCountry",
  billingCountry: "ClientManagement.CreateClientProfile.BillingCountry",
  taxIDVATNumber: "ClientManagement.CreateClientProfile.TaxIDVATNumber",
  localClientRelationshipOwner:
    "ClientManagement.CreateClientProfile.LocalClientRelationshipOwner",
  siretNumber: "ClientManagement.CreateClientProfile.SiretNumber",
  btwNummer: "ClientManagement.CreateClientProfile.BTWNummer",
  nifNumber: "ClientManagement.CreateClientProfile.NIFNumber",
  abnNumber: "ClientManagement.CreateClientProfile.ABNNumber",
  nzbnNumber: "ClientManagement.CreateClientProfile.NZBNNumber",
  binNumber: "ClientManagement.CreateClientProfile.BINNumber",
  cinNumber: "ClientManagement.CreateClientProfile.CINNumber",
  tinNumber: "ClientManagement.CreateClientProfile.TINNumber",
  qualifiedInvoiceNumber:
    "ClientManagement.CreateClientProfile.QualifiedInvoiceNumber",
  dedicatedProjectManager:
    "ClientManagement.CreateClientProfile.DedicatedProjectManager",
  originDate: "ClientManagement.CreateClientProfile.OriginDate",
  vATAndABNDifferent: "ClientManagement.CreateClientProfile.VATAndABNDifferent",
  siretNumberPlaceholderText:
    "ClientManagement.CreateClientProfile.SiretNumberPlaceholderText",
  siretNumberValidFormatMessage:
    "ClientManagement.CreateClientProfile.SiretNumberValidFormatMessage",
  bTWNummerPlaceholderText:
    "ClientManagement.CreateClientProfile.BTWNummerPlaceholderText",
  bTWNummerPrefix: "ClientManagement.CreateClientProfile.BTWNummerPrefix",
  bTWNummerValidFormatMessage:
    "ClientManagement.CreateClientProfile.BTWNummerValidFormatMessage",
  nIFNumberPlaceholderText1:
    "ClientManagement.CreateClientProfile.NIFNumberPlaceholderText1",
  nIFNumberPlaceholderText2:
    "ClientManagement.CreateClientProfile.NIFNumberPlaceholderText2",
  nIFNumberPrefix: "ClientManagement.CreateClientProfile.NIFNumberPrefix",
  nIFNumberValidFormatMessage1:
    "ClientManagement.CreateClientProfile.NIFNumberValidFormatMessage1",
  nIFNumberValidFormatMessage2:
    "ClientManagement.CreateClientProfile.NIFNumberValidFormatMessage2",
  cINNumberPlaceholderText:
    "ClientManagement.CreateClientProfile.CINNumberPlaceholderText",
  cINNumberValidFormatMessage:
    "ClientManagement.CreateClientProfile.CINNumberValidFormatMessage",
  tINNumberPlaceholderText:
    "ClientManagement.CreateClientProfile.TINNumberPlaceholderText",
  tINNumberValidFormatMessage:
    "ClientManagement.CreateClientProfile.TINNumberValidFormatMessage",

  contactsTitle: "ClientManagement.CreateClientComponent.Contacts",
  addContactTitle: "ClientManagement.CreateClientComponent.AddContact",
  nameLabel: "ClientManagement.AddContact.Name",
  addContactProfileHeading: "ClientManagement.AddContact.ProfileHeading",
  prefixLabel: "ClientManagement.AddContact.Prefix",
  firstNameLabel: "ClientManagement.AddContact.FirstName",
  lastNameLabel: "ClientManagement.AddContact.LastName",
  jobTitleLabel: "ClientManagement.AddContact.JobTitle",
  jobTitleValidationMessage:
    "ClientManagement.AddContact.JobTitleValidationMessage",
  telePhoneLabel: "ClientManagement.AddContact.Telephone",
  mobileLabel: "ClientManagement.AddContact.Mobile",
  workEmailLabel: "ClientManagement.AddContact.WorkEmail",
  usedByClientHeading: "ClientManagement.AddContact.UsedByClientHeading",
  noUsedByClientAvailableLabel:
    "ClientManagement.AddContact.NoUsedByClientAvailable",
  surveyLanguageLabel: "ClientManagement.AddContact.Surveylanguage",
  statusLabel: "ClientManagement.AddContact.Status",
  contactDetailsHeading: "ClientManagement.AddContact.ContactDetailsHeading",
  contactTypeLabel: "ClientManagement.AddContact.ContactType",
  selectedContactTypesLabel: "ClientManagement.AddContact.SelectedContactTypes",
  surveyContactLabel: "ClientManagement.AddContact.SurveyContact",
  contactSuccessfullyAddedMessage:
    "ClientManagement.AddContact.ContactAddedMessage",
  contactSuccessfullyUpdatedMessage:
    "ClientManagement.EditContact.ContactUpdatedMessage",
  editContactButtonLabel: "ClientManagement.AddContact.EditContactButton",
  updateContactButtonLabel: "ClientManagement.AddContact.UpdateContactButton",
  saveContactButtonLabel: "ClientManagement.AddContact.EditContactButton",
  closeContactButtonLabel: "ClientManagement.AddContact.EditContactButton",
  editContactTitle: "ClientManagement.AddContact.EditContactPopupTitle",
  viewContactTitle: "ClientManagement.AddContact.ViewContactPopupTitle",
  selectedAsLabel: "ClientManagement.AddContact.SelectedAsText",
  cancelActionConfirmLabel: "ClientManagement.AddContact.CancelActionMessage",
  addActionConfirmLabel: "ClientManagement.AddContact.AddContactActionMessage",
  editCancelActionConfirmLabel:
    "ClientManagement.AddContact.EditCancelActionMessage",
  updateActionConfirmLabel:
    "ClientManagement.AddContact.UpdateContactActionMessage",
  surveyLanguageDropdown: "ClientManagement.AddContact.SurveyLanguagesList",
  statusDropdown: "ClientManagement.AddContact.StatusList",
  contactTypeDropdown: "ClientManagement.AddContact.ContactTypeList",
  prefixDropdown: "ClientManagement.AddContact.PrefixList",
  warningBillingCountry:
    "ClientManagement.ClientMailingAddress.WarningBillingCountry",
  clientSpecificContentTitle:
    "ClientManagement.CreateClient.ClientSpecificContent",
  addClientSpecificContentButton:
    "ClientSpecificContent.AddClientSpecificContentButton",
  locale: "ClientSpecificContent.Locale",
  programClass: "ClientSpecificContent.ProgramClass",
  programTemplate: "ClientSpecificContent.ProgramTemplate",
  resourceID: "ClientSpecificContent.ResourceID",
  resourceName: "ClientSpecificContent.ResourceName",
  resourceType: "ClientSpecificContent.ResourceType",
  solutionOfferings: "ClientSpecificContent.SolutionOfferings",
  countryClientSpecific: "ClientSpecificContent.Country",
  actionClientSpecific: "ClientSpecificContent.Action",
  resourceTypeList: "ClientSpecificContent.ResourceTypeList",
  deleteGroupActionText: "ClientSpecificContent.DeleteGroupActionText",
  modifyContactTypeMessage:
    "ClientManagement.AddContact.ModifyContactTypeMessage",
  groupDeletedMessage: "ClientSpecificContent.GroupDeletedMessage",
  editClientHeading: "ClientManagement.CreateClient.EditClientHeading",
  viewClientHeading: "ClientManagement.CreateClient.ViewClientHeading",
  viewHierarchyLinkText: "ClientManagement.CreateClient.ViewHierarchyLinkText",
  clientSpecificActivitiesAndDeliverables:
    "ClientManagement.CreateClient.ActivitiesList",
  pleaseChooseAtLeastOneContactTypeOrMarkThisContactAsASurveyContact:
    "ClientManagement.AddContact.PleaseChooseAtLeastOneContactTypeOrMarkThisContactAsASurveyContact",
  emailAlreadyInUseError:
    "ClientManagement.AddContact.AContactAlreadyExistsPleaseTryWithADifferentEmailAddress",
  noteMessage:
    "ClientManagement.AddContact.TheseChangesWillBeAppliedToTheClientSpecificContactOnlyNote",
  modifyContactStatusMessage:
    "ClientManagement.AddContact.ModifyContactStatusMessage",
  salesOffice: "ClientManagement.CreateClientProfile.SalesOffice",
  contactTypeShouldNotBeUpdatedMessage:
    "ClientManagement.AddContact.ContactTypeShouldNotBeUpdatedMessage",
} as const;

export const billingAndPurchaseOrderKeys = {
  billingDetailsAndPOTitle:
    "ClientManagement.CreateClient.BillingDetailsAndPurchaseOrder",
  billingDetailsAndConfigurationTab:
    "BillingDetailsAndPurhaseOrder.BillingDetailsAndConfigurationTab",
  purchaseOrderTrackingTab:
    "BillingDetailsAndPurhaseOrder.PurchaseOrderTrackingTab",
  billingDetailsHeading: "BillingDetailsAndPurhaseOrder.BillingDetailsHeading",
  selectApplicable: "BillingDetailsAndPurhaseOrder.SelectApplicable",
  consolidatedInvoicing: "BillingDetailsAndPurhaseOrder.ConsolidatedInvoicing",
  consolidateInvoiceAlertmessage:
    "BillingDetailsAndPurhaseOrder.ConsolidateInvoiceAlertmessage",
  activeCompany: "BillingDetailsAndPurhaseOrder.ActiveCompany",
  rebateClient: "BillingDetailsAndPurhaseOrder.RebateClient",
  earlyPayDiscount: "BillingDetailsAndPurhaseOrder.EarlyPayDiscount",
  earlyPayDays: "BillingDetailsAndPurhaseOrder.EarlyPayDays",
  earlyPayPercentage: "BillingDetailsAndPurhaseOrder.EarlyPayPercentage",
  invoiceLanguage: "BillingDetailsAndPurhaseOrder.InvoiceLanguageDropDown",
  earlyPayPercentageErrorMessage:
    "BillingDetailsAndPurhaseOrder.EarlyPayPercentageErrorMessage",
  billingConfigurationsHeading:
    "BillingDetailsAndPurhaseOrder.BillingConfigurationsHeading",
  addConfiguration: "BillingDetailsAndPurhaseOrder.AddConfiguration",
  configurationNumber: "BillingDetailsAndPurhaseOrder.Configuration",
  deleteConfigurationActionText:
    "BillingDetailsAndPurhaseOrder.DeleteConfigurationActionText",
  billingConfigurationName:
    "BillingDetailsAndPurhaseOrder.BillingConfigurationName",
  lineOfBusiness: "BillingDetailsAndPurhaseOrder.LineOfBusiness",
  billingContactName: "BillingDetailsAndPurhaseOrder.BillingContact",
  hrContact: "BillingDetailsAndPurhaseOrder.HRContact",
  additionalContactForInvoice:
    "BillingDetailsAndPurhaseOrder.AdditionalContactForInvoice",
  outreachEligibility: "BillingDetailsAndPurhaseOrder.OutreachEligibility",
  costCentre: "BillingDetailsAndPurhaseOrder.CostCentre",
  businessUnit: "BillingDetailsAndPurhaseOrder.BusinessUnit",
  poNumber: "BillingDetailsAndPurhaseOrder.PONumber",
  candidateLocation: "BillingDetailsAndPurhaseOrder.CandidateLocation",
  site: "BillingDetailsAndPurhaseOrder.Site",
  projectManager: "BillingDetailsAndPurhaseOrder.ProjectManager",
  projectAdminCoordinator:
    "BillingDetailsAndPurhaseOrder.ProjectAdminCoordinator",
  additionalProjectResource:
    "BillingDetailsAndPurhaseOrder.AdditionalProjectResource",
  clientInformation1: "BillingDetailsAndPurhaseOrder.ClientInformation1",
  clientInformation2: "BillingDetailsAndPurhaseOrder.ClientInformation2",
  clientInformation3: "BillingDetailsAndPurhaseOrder.ClientInformation3",
  contractIdAndName: "BillingDetailsAndPurhaseOrder.ContractIDAndName",
  opportunityId: "BillingDetailsAndPurhaseOrder.OpportunityID",
  opportunityName: "BillingDetailsAndPurhaseOrder.OpportunityName",
  opportunityAlreadyMappedForClientMessage:
    "BillingDetailsAndPurhaseOrder.OpportunityAlreadyMappedForClientMessage",
  opportunityIDAssociatedWithAnotherClient:
    "BillingDetailsAndPurhaseOrder.OpportunityIDAssociatedWithAnotherClient",
  opportunityIDAssociatedWithAnotherContract:
    "BillingDetailsAndPurhaseOrder.OpportunityIDAssociatedWithAnotherContract",
  opportunityIDAssociatedWithProgramMessage:
    "BillingDetailsAndPurhaseOrder.OpportunityIDAssociatedWithProgramMessage",
  opportunityIDMustBeValidatedMessage:
    "BillingDetailsAndPurhaseOrder.OpportunityIDMustBeValidatedMessage",
  opportunityIDInvalidMessage:
    "BillingDetailsAndPurhaseOrder.OpportunityIDInvalidMessage",
  paymentTermsDropDown: "BillingDetailsAndPurhaseOrder.PaymentTermsDropDown",
  addProgramTemplate: "BillingDetailsAndPurhaseOrder.AddProgramTemplate",
  programTemplateNumber: "BillingDetailsAndPurhaseOrder.ProgramTemplateNumber",
  deleteProgramTemplateActionText:
    "BillingDetailsAndPurhaseOrder.DeleteProgramTemplateActionText",
  programTemplate: "BillingDetailsAndPurhaseOrder.ProgramTemplate",
  programTemplateDeletedMessage:
    "BillingDetailsAndPurhaseOrder.ProgramTemplateDeletedMessage",
  alternateDisplayName: "BillingDetailsAndPurhaseOrder.AlternateDisplayName",
  billingType: "BillingDetailsAndPurhaseOrder.BillingType",
  billingTrigger: "BillingDetailsAndPurhaseOrder.BillingTrigger",
  currency: "BillingDetailsAndPurhaseOrder.Currency",
  fee: "BillingDetailsAndPurhaseOrder.Fee",
  outreachEligibilityDropdown:
    "BillingDetailsAndPurhaseOrder.OutreachEligibilityList",
  earlyPayTooltipMessage:
    "BillingDetailsAndPurhaseOrder.EarlyPayToolTipMessage",
  configurationDeletedMessage:
    "BillingDetailsAndPurhaseOrder.ConfigurationDeletedMessage",
  addBillingContactMessage:
    "BillingDetailsAndPurhaseOrder.AddBillingContactMessage",
  addHrContactMessage: "BillingDetailsAndPurhaseOrder.AddHRContactMessage",
  billingTriggerDropdown: "BillingDetailsAndPurhaseOrder.BillingTriggerList",
  billingTypeDropdown: "BillingDetailsAndPurhaseOrder.BillingTypeList",
  duplicateRecordBillingConfigurationError:
    "BillingDetailsAndPurhaseOrder.DuplicateRecordBillingConfigurationError",
  duplicateRecordBillingConfigProgramTemplateError:
    "BillingDetailsAndPurhaseOrder.DuplicateRecordProgramTemplateError",
  salesOffice: "BillingDetailsAndPurhaseOrder.SalesOffice",
  poBalanceExhaustedErrorMessage:
    "BillingDetailsAndPurhaseOrder.POBalanceExhaustedErrorMessage",
  thisBillingConfigurationAlreadyExists:
    "BillingDetailsAndPurhaseOrder.ThisBillingConfigurationAlreadyExists",
  thisProgramTemplateAlreadyExists:
    "BillingDetailsAndPurhaseOrder.ThisProgramTemplateAlreadyExists",
  specialBillingInstructions:
    "BillingDetailsAndPurhaseOrder.SpecialBillingInstructions",
  selectPreferencesHeader:
    "BillingDetailsAndPurhaseOrder.SelectPreferencesHeader",
  selectedPreferencesHeader:
    "BillingDetailsAndPurhaseOrder.SelectedPreferencesHeader",
  employeeIDCheckbox: "BillingDetailsAndPurhaseOrder.EmployeeIDCheckbox",
  employeeBandCheckbox: "BillingDetailsAndPurhaseOrder.EmployeeBandCheckbox",
  parentClientInactiveWarningMessage:
    "BillingDetailsAndPurhaseOrder.ParentClientInactiveWarningMessage",
  multipleBillingConfigValidationMessage:
    "BillingDetailsAndPurhaseOrder.MultipleBillingConfigValidationMessage",

  // Add Program template
  addProgramTemplateTitle: "ClientManagement.CreateClient.AddProgramTemplate",
  activities: "AddProgramTemplate.Activities",
  addMilestone: "AddProgramTemplate.AddMilestone",
  addSchedule: "AddProgramTemplate.AddSchedule",
  editMilestone: "AddProgramTemplate.EditMilestoneSubHeading",
  editSchedule: "AddProgramTemplate.EditScheduleSubHeading",
  amount: "AddProgramTemplate.Amount",
  configureMilestoneBasedBillingHeading:
    "AddProgramTemplate.ConfigureMilestoneBasedBillingHeading",
  configureScheduleBasedBillingHeading:
    "AddProgramTemplate.ConfigureScheduleBasedBillingHeading",
  feePercentage: "AddProgramTemplate.FeePercentage",
  milestone: "AddProgramTemplate.Milestone",
  milestoneNumber: "AddProgramTemplate.MilestoneNumber",
  percentage: "AddProgramTemplate.Percentage",
  schedule: "AddProgramTemplate.Schedule",
  scheduleFrequency: "AddProgramTemplate.ScheduleFrequency",
  scheduleNumber: "AddProgramTemplate.ScheduleNumber",
  schedulePeriod: "AddProgramTemplate.SchedulePeriod",

  totalAmount: "AddProgramTemplate.TotalAmount",
  totalPercentage: "AddProgramTemplate.TotalPercentage",
  value: "AddProgramTemplate.Value",
  scheduleFrequencyMonthlyList:
    "AddProgramTemplate.ScheduleFrequencyMonthlyList",

  scheduleFrequencyWeeklyList: "AddProgramTemplate.ScheduleFrequencyWeeklyList",

  schedulePeriodList: "AddProgramTemplate.SchedulePeriodList",
  valueList: "AddProgramTemplate.ValueList",

  scheduleTableColumnHeading: "AddProgramTemplate.ScheduleTableColumnHeading",
  scheduleFrequencyTableColumnHeading:
    "AddProgramTemplate.ScheduleFrequencyTableColumnHeading",
  percentageTableColumnHeading:
    "AddProgramTemplate.PercentageTableColumnHeading",
  amountTableColumnHeading: "AddProgramTemplate.AmountTableColumnHeading",
  actionTableColumnHeading: "AddProgramTemplate.ActionTableColumnHeading",
  activitiesTableColumnHeading:
    "AddProgramTemplate.ActivitiesTableColumnHeading",
  milestoneTableColumnHeading: "AddProgramTemplate.MilestoneTableColumnHeading",
  billingTypeList: "AddProgramTemplate.BillingTypeList",
  noMilestonesFoundMessage: "AddProgramTemplate.NoMilestonesFoundMessage",
  noSchedulesFoundMessage: "AddProgramTemplate.NoSchedulesFoundMessage",

  totalAmountMustEqualProgramFeeErrorMessage:
    "AddProgramTemplate.TotalAmountMustEqualProgramFeeErrorMessage",
  amountCannotEqualProgramFeeErrorMessage:
    "AddProgramTemplate.AmountCannotEqualProgramFeeErrorMessage",
  amountCannotGreaterThanProgramFeeErrorMessage:
    "AddProgramTemplate.AmountCannotGreaterThanProgramFeeErrorMessage",
  pleaseFillProgramFeeErrorMessage:
    "AddProgramTemplate.PleaseFillProgramFeeErrorMessage",
  programFee: "AddProgramTemplate.ProgramFee",
  billingTriggerList: "AddProgramTemplate.BillingTriggerList",
  totalPercentageCannotExceed100:
    "AddProgramTemplate.TotalPercentageCannotExceed100",
  areYouSureYouWantToChangeTheBillingType:
    "AddProgramTemplate.AreYouSureYouwantToChangeTheBillingType",
  areYouSureYouWantToChangeTheProgramTemplate:
    "AddProgramTemplate.AreYouSureYouWantToChangeTheProgramTemplate",
  selectFrequencyThatFallsBetweenThePreviousAndNextSchedules:
    "AddProgramTemplate.SelectFrequencyThatFallsBetweenThePreviousAndNextSchedules",
  pleaseCreateMoreThanOneScheduleAndDistributeTheAmountAccordingly:
    "AddProgramTemplate.PleaseCreateMoreThanOneScheduleAndDistributeTheAmountAccordingly",
};

export const documentSiteCoreKeys = {
  documentsTitle: "ClientManagement.CreateClient.Documents",
  action: "Documents.Action",
  alertUploadDocumentLimit: "Documents.AlertUploadDocumentLimit",
  contractTab: "Documents.ContractTab",
  DeleteDocumentActionText: "Documents.DeleteDocumentActionText",
  documentDeleted: "Documents.DocumentDeleted",
  documentId: "Documents.DocumentId",
  documentName: "Documents.DocumentName",
  exclusivityId: "Documents.Exclusivity",
  expirationDate: "Documents.ExpirationDate",
  geoScope: "Documents.GeoScope",
  information: "Documents.Information",
  noRecordsAvailable: "Documents.NoRecordsAvailable",
  noRecordsAvailableArchiveTabMessage:
    "Documents.NoRecordsAvailableArchiveTabMessage",
  othersTab: "Documents.OthersTab",
  archiveTab: "Documents.ArchivedTab",
  status: "Documents.Status",
  notes: "Documents.Notes",
  uploadNewDocument: "Documents.UploadNewDocument",
  inheritDocument: "Documents.InheritDocumentsOption",
  exclusivityList: "Documents.ExclusivityList",
  geoScopeList: "Documents.GeoScopeList",
  contractStatusList: "Documents.ContractStatusList",
  othersStatusList: "Documents.OthersStatusList",
  deleteDocumentActionText:
    "Documents.AreYouSureYouWantToDeleteThisContractDocument",
  cancelContract: "Documents.CancelContract",
  cancelContractHeading: "Documents.CancelContractHeading",
  cancelContractActionText: "Documents.CancelContractActionText",
  cancellationReason: "Documents.CancellationReason",
  contractCanceledMessage: "Documents.ContractCanceledMessage",
  documentStatusUpdateActionText: "Documents.DocumentStatusUpdateActionText",
  documentStatusUpdatedMessage: "Documents.DocumentStatusUpdatedMessage",
  cancellationReasonList: "Documents.CancellationReasonList",
  documentMarkActiveMessage: "Documents.DocumentMarkActiveMessage",
  documentActiveConfirmationboxText:
    "Documents.AreYouSureYouWantToChangeTheStatusToActive",
  documentMarkExpireMessage: "Documents.DocumentMarkExpireMessage",
  documentExpiredConfirmationboxText:
    "Documents.AreYouSureYouWantToChangeTheStatusToExpired",
  markAsNoLongerValidAction: "Documents.MarkAsNoLongerValidAction",
  confirmPopupForMarkAsNoLongerValid:
    "Documents.AreYouSureYouWantToMarkTheDocumentAsNoLongerValid",
  documentMarkedNoLongerValid: "Documents.DocumentMarkedNoLongerValid",
  documentArchiveConfirmation: "Documents.ArchiveDocumentActionText",
  archivePopupHeader: "Documents.ArchivePopupHeader",
  archiveReasonDropdown: "Documents.ArchivePopup.ArchiveReasonDropdown",
  archiveReasonList: "Documents.ArchiveReasonList",
  othersArchiveReasonList: "Documents.OthersArchiveReasonList",
  documentArchived: "Documents.DocumentArchived",
  documentType: "Documents.DocumentTypeDropdown",
  archiveStatusList: "Documents.ArchivedStatusList",
  documentTypeList: "Documents.DocumentTypeList",
  effectiveDate: "Documents.EffectiveDate",
  restoreMsg: "Documents.DocumentRestoredMessage",
  restoreConfirmationText:
    "Documents.AreYouSureYouWantRestoreThisContractDocument",
  contractID: "Documents.ContractID",
  contractName: "Documents.ContractName",
  usedByClient: "Documents.UsedByClient",
  documentOrigin: "Documents.DocumentOrigin",
  documentOriginList: "Documents.DocumentOriginList",
  documentUnmappedToastMessage: "Documents.DocumentUnmappedToastMessage",
  contractCannotBeUnmappedMessage: "Documents.ContractCannotBeUnmappedMessage",
};

export const clientSpecificContentKeys = {
  clientSpecificContentTitle:
    "ClientManagement.CreateClient.ClientSpecificContent",
  action: "ClientSpecificContent.Action",
  addClientSpecificContentButton:
    "ClientSpecificContent.AddClientSpecificContentButton",
  addClientSpecificContentHeading:
    "ClientSpecificContent.AddClientSpecificContentHeading",
  addResourceButtonText: "ClientSpecificContent.AddResourceButtonText",
  addTemplateButtonText: "ClientSpecificContent.AddTemplateButtonText",
  country: "ClientSpecificContent.Country",
  editClientSpecificContentHeading:
    "ClientSpecificContent.EditClientSpecificContentHeading",
  editGroupButtontext: "ClientSpecificContent.EditGroupButtontext",
  groupName: "ClientSpecificContent.GroupName",
  groupUpdateActionText: "ClientSpecificContent.GroupUpdateActionText",
  groupUpdatedMessage: "ClientSpecificContent.GroupUpdateMessage",
  language: "ClientSpecificContent.Language",
  locale: "ClientSpecificContent.Locale",
  addProgramTemplateNote: "ClientSpecificContent.AddProgramTemplateNote",
  addResourcesNote: "ClientSpecificContent.AddResourcesNote",
  editProgramTemplateNote: "ClientSpecificContent.EditProgramTemplateNote",
  editResourcesNote: "ClientSpecificContent.EditResourcesNote",
  viewClientSpecificContentNote:
    "ClientSpecificContent.ViewClientSpecificContentNote",
  programClass: "ClientSpecificContent.ProgramClass",
  programTemplate: "ClientSpecificContent.ProgramTemplate",
  programTemplateHeading: "ClientSpecificContent.ProgramTemplateHeading",
  programTemplatesTab: "ClientSpecificContent.ProgramTemplatesTab",
  resourceHeading: "ClientSpecificContent.ResourceHeading",
  resourceID: "ClientSpecificContent.ResourceID",
  resourceName: "ClientSpecificContent.ResourceName",
  resourcesTab: "ClientSpecificContent.ResourcesTab",
  resourceType: "ClientSpecificContent.ResourceType",
  solutionOfferings: "ClientSpecificContent.SolutionOfferings",
  success: "ClientSpecificContent.Success",
  successMessage: "ClientSpecificContent.SuccessMessage",
  viewClientSpecificContentHeading:
    "ClientSpecificContent.ViewClientSpecificContentHeading",
  resourceTypeList: "ClientSpecificContent.ResourceTypeList",
  deleteResourceActionText: "ClientSpecificContent.DeleteResourceActionText",
  resourceDeletedMessage: "ClientSpecificContent.ResourceDeletedMessage",
  saveClientSpecificContentActionText:
    "ClientSpecificContent.SaveClientSpecificContentActionText",
  noRecordsAvailable: "ClientSpecificContent.NoRecordsAvailable",
  duplicateRecordProgramTemplateError:
    "ClientSpecificContent.DuplicateRecordProgramTemplateError",
  duplicateRecordResourceError:
    "ClientSpecificContent.DuplicateRecordResourceError",
  uniqueGroupNameError: "ClientSpecificContent.UniqueGroupNameValidationError",
};

export const uploadDocumentSiteCoreKeys = {
  uploadDocumentTitle: "ClientManagement.CreateClient.UploadNewDocument",
  accountDirector: "UploadNewDocument.AccountDirector",
  allowedFileTypes: "UploadNewDocument.AllowedFileTypes",
  attachmentHeading: "UploadNewDocument.AttachmentHeading",
  classification: "UploadNewDocument.Classification",
  contractGeoScope: "UploadNewDocument.ContractGeoScope",
  contractGeoScopeDetail: "UploadNewDocument.ContractGeoScopeDetail",
  opportunityID: "UploadNewDocument.OpportunityID",
  opportunityName: "UploadNewDocument.OpportunityName",
  opportunityAlreadyMappedToContractMessage:
    "UploadNewDocument.OpportunityAlreadyMappedToContractMessage",
  opportunityAlreadyMappedForClientMessage:
    "UploadNewDocument.OpportunityAlreadyMappedForClientMessage",
  opportunityIDAssociatedWithAnotherClient:
    "UploadNewDocument.OpportunityIDAssociatedWithAnotherClient",
  opportunityIDAssociatedWithAnotherContract:
    "UploadNewDocument.OpportunityIDAssociatedWithAnotherContract",
  opportunityIDAssociatedWithProgramMessage:
    "UploadNewDocument.OpportunityIDAssociatedWithProgramMessage",
  opportunityIDMustBeValidatedMessage:
    "UploadNewDocument.OpportunityIDMustBeValidatedMessage",
  opportunityIDInvalidMessage: "UploadNewDocument.OpportunityIDInvalidMessage",
  countryOfOwnership: "UploadNewDocument.CountryOfOwnership",
  customDeliverables: "UploadNewDocument.CustomDeliverables",
  documentExists: "UploadNewDocument.DocumentExists",
  documentType: "UploadNewDocument.DocumentType",
  contractId: "UploadNewDocument.ContractID",
  documentUpdated: "UploadNewDocument.DocumentUpdated",
  documentUploaded: "UploadNewDocument.DocumentUploaded",
  dropFileOrBrowse: "UploadNewDocument.DropFileOrBrowse",
  browse: "UploadNewDocument.Browse",
  durationOfContractSOWTerm: "UploadNewDocument.DurationOfContractSOWTerm",
  editDocumentButtonText: "UploadNewDocument.EditDocumentButtonText",
  editDocumentHeading: "UploadNewDocument.EditDocumentHeading",
  effectiveDate: "UploadNewDocument.EffectiveDate",
  engagementType: "UploadNewDocument.EngagementType",
  exclusivity: "UploadNewDocument.Exclusivity",
  fileFormatErrorMessage: "UploadNewDocument.FileFormatErrorMessage",
  maxFileSizeErrorMessage: "UploadNewDocument.MaxFileSizeErrorMessage",
  maximumFileSizeAllowed: "UploadNewDocument.MaximumFileSizeAllowed",
  paymentTermsDropDown: "UploadNewDocument.PaymentTermsDropDown",
  profileHeading: "UploadNewDocument.ProfileHeading",
  serviceLevelAgreements: "UploadNewDocument.ServiceLevelAgreements",
  sowAutoRenewalClause: "UploadNewDocument.SOWAutoRenewalClause",
  sowAutoRenewalTerms: "UploadNewDocument.SOWAutoRenewalTerms",
  sowContractEffectiveDate: "UploadNewDocument.SOWContractEffectiveDate",
  sowExpirationDate: "UploadNewDocument.SOWExpirationDate",
  sowStatus: "UploadNewDocument.SOWStatus",
  status: "UploadNewDocument.Status",
  uploadDate: "UploadNewDocument.UploadDate",
  uploadDocument: "UploadNewDocument.UploadDocument",
  viewDocumentHeading: "UploadNewDocument.ViewDocumentHeading",
  autoRenewalClauseList: "UploadNewDocument.AutoRenewalClauseList",
  classificationList: "UploadNewDocument.ClassificationList",
  customDeliverablesList: "UploadNewDocument.CustomDeliverablesList",
  documentTypeList: "UploadNewDocument.DocumentTypeList",
  engagementTypeList: "UploadNewDocument.EngagementTypeList",
  exclusivityList: "UploadNewDocument.ExclusivityList",
  serviceLevelAgreementList: "UploadNewDocument.ServiceLevelAgreementList",
  statusList: "UploadNewDocument.StatusList",
  othersStatusList: "UploadNewDocument.OthersStatusList",
  customDeliverablesLis: "UploadNewDocument.CustomDeliverablesList",
  contractStatusList: "UploadNewDocument.ContractStatusList",
  actionText: "UploadNewDocument.UploadDocumentActionText",
  confirmation: "UploadNewDocument.UploadDocumentConfirmation",
  documentDetailsHeading: "UploadNewDocument.DocumentDetailsHeading",
  errorSelectAtLeastOneCountry:
    "UploadNewDocument.SelectAtleastOneCountryMessage",
  errorSelectAtLeastTwoCountry:
    "UploadNewDocument.SelectAtleastTwoCountriesMessage",
  editContractStatusList: "UploadNewDocument.EditContractStatusList",
  updateDocumentConfirmationPopupDescription:
    "UploadNewDocument.UpdateDocumentConfirmationPopupDescription",
  updateDocumentConfirmationPopupHeading:
    "UploadNewDocument.UpdateDocumentConfirmationPopupHeading",
  documentSavedConfirmationMessage:
    "UploadNewDocument.DocumentSavedConfirmationMessage",
  expirationDateMustBeGreaterThanEffectiveDate:
    "UploadNewDocument.ExpirationDateMustBeGreaterThanEffectiveDate",
  effectiveDateMustBeLesserThanExpirationDate:
    "UploadNewDocument.EffectiveDateMustBeLesserThanExpirationDate",

  maximumOf180MonthsAllowed: "UploadNewDocument.MaximumOf180MonthsAllowed",
  maximumOf200MonthsAllowed: "UploadNewDocument.MaximumOf200MonthsAllowed",
  maximumOf100MonthsAllowed: "UploadNewDocument.MaximumOf100MonthsAllowed",
  maximumOf90DaysAllowed: "UploadNewDocument.MaximumOf90DaysAllowed",
  contractProductLineDropdown: "UploadNewDocument.ContractProductLineDropdown",
};

export const inheritDocumentSiteCoreKeys = {
  inheritDocumentTitle:
    "ClientManagement.CreateClientComponent.InheritDocuments",
  clientCode: "InheritDocuments.ResultSection.ClientCode",
  clientName: "InheritDocuments.ResultSection.ClientName",
  contractID: "InheritDocuments.ResultSection.ContractID",
  documentName: "InheritDocuments.ResultSection.DocumentName",
  documentType: "InheritDocuments.ResultSection.DocumentType",
  documentStatus: "InheritDocuments.ResultSection.DocumentStatus",
  effectiveDate: "InheritDocuments.ResultSection.EffectiveDate",
  expirationDate: "InheritDocuments.ResultSection.ExpirationDate",
  inheritButton: "InheritDocuments.ResultSection.InheritButton",
  proceedButton: "InheritDocuments.ResultSection.ProceedButton",
  stayHereButton: "InheritDocuments.ResultSection.StayHereButton",
  redirectToNewTabConfirmationMessage:
    "InheritDocuments.ResultSection.RedirectToNewTabConfirmationMessage",
  resultSectionTitle:
    "CreateClientComponent.InheritDocuments.ResultSectionTitle",
  documentsInheritedToastMessage:
    "CreateClientComponent.InheritDocuments.DocumentsInheritedToastMessage",
  documentStatusList:
    "CreateClientComponent.InheritDocuments.DocumentStatusList",
  documentTypeList: "CreateClientComponent.InheritDocuments.DocumentTypeList",
  searchSectionTitle:
    "CreateClientComponent.InheritDocuments.SearchSectionTitle",
  searchContractID: "InheritDocuments.SearchSection.ContractID",
  searchDocumentName: "InheritDocuments.SearchSection.DocumentName",
  searchDocumentType: "InheritDocuments.SearchSection.DocumentType",
  searchDocumentNameMustBeAtLeast3Characters:
    "InheritDocuments.SearchSection.DocumentNameMustBeAtLeast3Characters",
};

export const purchaseOrdersListSiteCoreKeys = {
  purchaseOrderTitle: "ClientManagement.CreateClient.PurchaseOrdersList",
  action: "PurchaseOrdersList.Action",
  poNumber: "PurchaseOrdersList.PONumber",
  poDate: "PurchaseOrdersList.PODate",
  poStatus: "PurchaseOrdersList.POStatus",
  currentPoAmount: "PurchaseOrdersList.CurrentPOAmount",
  poExpiryDate: "PurchaseOrdersList.POExpiryDate",
  poEffectiveDate: "PurchaseOrdersList.POEffectiveDate",
  addPurchaseOrderCta: "PurchaseOrdersList.AddPurchaseOrderCTA",
  manageTransactionHeading: "PurchaseOrdersList.ManageTransactionHeading",
  managePoTransactionsCta: "PurchaseOrdersList.ManagePOTransactionsCTA",
  viewPoTransactionsCta: "PurchaseOrdersList.ViewPOTransactionsCTA",
  viewPoDetails: "PurchaseOrdersList.ViewPODetailsOption",
  reOpenPO: "PurchaseOrdersList.ReOpenOption",
  reOpenDate: "PurchaseOrdersList.ReOpenDate",
  reOpenReasonDropdown: "PurchaseOrdersList.ReOpenReasonDropdown",
  poReOpenReasonList: "PurchaseOrdersList.POReOpenReasonList",
  purchaseOrderReOpenedToastMessage:
    "PurchaseOrdersList.PurchaseOrderReOpenedToastMessage",
  reOpenPurchaseOrderHeader: "PurchaseOrdersList.ReOpenPurchaseOrderHeader",
  addPurchaseOrderHeading: "PurchaseOrdersList.AddPurchaseOrderHeading",
  editPurchaseOrderHeading: "PurchaseOrdersList.EditPurchaseOrderHeading",
  poAmount: "PurchaseOrdersList.POAmount",
  poExpirationDate: "PurchaseOrdersList.POExpirationDate",
  selectType: "PurchaseOrdersList.SelectType",
  deductAmount: "PurchaseOrdersList.DeductAmount",
  deductAmountRadioButton: "PurchaseOrdersList.DeductAmountRadioButton",
  topUpAmount: "PurchaseOrdersList.TopUpAmount",
  topUpAmountRadioButton: "PurchaseOrdersList.TopUpAmountRadioButton",
  topUpButtonText: "PurchaseOrdersList.TopUpButtonText",
  totalPoAmount: "PurchaseOrdersList.TotalPOAmount",
  balancePoAmountText: "PurchaseOrdersList.BalancePOAmountText",
  deductButtonText: "PurchaseOrdersList.DeductButtonText",
  poTransactionHistoryHeading: "PurchaseOrdersList.POTransactionHistoryHeading",
  startingPoBalance: "PurchaseOrdersList.StartingPOBalance",
  topUpDate: "PurchaseOrdersList.TopUpDate",
  topUpOrAdjustAmount: "PurchaseOrdersList.TopUpOrAdjustAmount",
  totalPoBalance: "PurchaseOrdersList.TotalPOBalance",
  viewPurchaseOrderHeading: "PurchaseOrdersList.ViewPurchaseOrderHeading",
  poAddSuccessMessage: "PurchaseOrdersList.POSavedMessage",
  addActionConfirmLabel: "PurchaseOrdersList.SaveConfirmationPopUpText",
  cancelActionConfirmLabel: "PurchaseOrdersList.CancelConfirmationPopUpText",
  poUpdateSuccessMessage: "PurchaseOrdersList.POUpdatedMessage",
  updateActionConfirmLabel: "PurchaseOrdersList.UpdateConfirmationPopUpText",
  editCancelActionConfirmLabel:
    "PurchaseOrdersList.EditCancelConfirmationPopUpText",
  statusList: "PurchaseOrdersList.StatusList",
  amountDeductedMessage: "PurchaseOrdersList.AmountDeductedMessage",
  amountAddedMessage: "PurchaseOrdersList.AmountAddedMessage",
  viewTransactionHeading: "PurchaseOrdersList.ViewTransactionHeading",
  deletePOActionText: "PurchaseOrdersList.DeletePOActionText",
  poDeletedMessage: "PurchaseOrdersList.PODeletedMessage",
  noPoAvailable: "PurchaseOrdersList.NoPOAvailableText",
  enterAnAmountLessThanYourCurrentPOBalance:
    "PurchaseOrdersList.EnterAnAmountLessThanYourCurrentPOBalance",
  expirationDateMustBeGreaterThanEffectiveDate:
    "PurchaseOrdersList.ExpirationDateMustBeGreaterThanEffectiveDate",
  effectiveDateMustBeLesserThanExpirationDate:
    "PurchaseOrdersList.EffectiveDateMustBeLesserThanExpirationDate",
  amount: "PurchaseOrdersList.Amount",
  transactionDate: "PurchaseOrdersList.TransactionDate",
  projectOrProgramKey: "PurchaseOrdersList.ProjectOrProgramKey",
  poNumberUniqueErrorMessage:
    "PurchaseOrdersList.ThePurchaseOrderShouldBeUnique",
  purchaseOrderNumberInUseError:
    "PurchaseOrdersList.ThePOYouAreTryingToDeleteIsCurrentlyAssociated",
  navigationConfirmationMessage:
    "PurchaseOrdersList.YouAreAboutToNavigateToAProgramOrProjectPageConfirmationMessage",
  transactionType: "PurchaseOrdersList.TransactionType",
  transactionTypeList: "PurchaseOrdersList.TransactionTypeList",
};

export const activitiesAndDeliverablesSiteCoreKeys = {
  informationPopup: "InformationPopup",
  description: "Description",
  cancelChanges: "CancelChanges",
  areYouSureToCancel: "CancelChanges.AreYouSureToCancel",
  manageLocale: "ManageLocale",
  viewLocaleTitle: "ManageLocale.ViewLocale",
  defaultEventsList: "DefaultEventsList",
  statusAll: "Status.All",

  activitiesList: "ClientManagement.CreateClient.ActivitiesList",
  createActivity: "ActivitiesList.CreateActivityLink",
  activityTypeHeader: "ActivitiesList.ActivityType",
  modalityHeader: "ActivitiesList.Modality",
  topicHeader: "ActivitiesList.Topic",
  // activityClassHeader: "ActivitiesList.ActivityClass",
  activityStatusHeader: "ActivitiesList.ActivityStatus",
  measurementHeader: "ActivitiesList.Quantity",
  unitsHeader: "ActivitiesList.Units",
  participantStatusHeader: "ActivitiesList.ParticipantStatus",
  actionHeader: "ActivitiesList.Action",
  activitiesNotAvailable: "ActivitiesList.ActivitiesNotAvailable",
  deliverablesNotAvailable: "DeliverablesList.DeliverablesNotAvailable",
  deleteActivityConfirmation: "ActivitiesList.DeleteActivityActionText",
  deletingActivity: "ActivitiesList.DeletingActivity",
  activityDeletedSuccessfully: "ActivitiesList.DeleteActivityCompletionText",
  listParticipantStatusList: "ActivitiesList.ParticipantStatusList",
  listStatusList: "ActivitiesList.StatusList",
  listActivityTypeList: "ActivitiesList.ActivityTypeList",
  listModalityList: "ActivitiesList.ModalityList",
  // listActivityClassList: "ActivitiesList.ActivityClassList",
  listUnitList: "ActivitiesList.UnitLists",
  listMinutesList: "ActivitiesList.MinutesList",
  thisActivityCannotBeDeletedBecauseItIsTaggedToAnExistingProgram:
    "ActivitiesList.ThisActivityCannotBeDeletedBecauseItIsTaggedToAnExistingProgram",

  createActivityKey: "ClientManagement.CreateClient.CreateActivity",
  updateLocale: "CreateActivity.UpdateLocale",
  updateLocaleActionMessage: "CreateActivity.UpdateLocaleActionMessage",
  defaultActivityValues: "CreateActivity.DefaultActivityValues",
  editActivityNote: "CreateActivity.IsClientSpecificActivityNote",
  createActivityNote: "CreateActivity.WillBeClientSpecificActivityNote",
  participantStatus: "CreateActivity.ParticipantStatus",
  activityType: "CreateActivity.ActivityType",
  activityClass: "CreateActivity.ActivityClass",
  modality: "CreateActivity.Modality",
  topic: "CreateActivity.Topic",
  deliverables: "CreateActivity.Deliverables",
  activityStatus: "CreateActivity.ActivityStatus",
  participantStatusList: "CreateActivity.ParticipantStatusList",
  activityTypeList: "CreateActivity.ActivityTypeList",
  modalityList: "CreateActivity.ModalityList",
  activityClassList: "CreateActivity.ActivityClassList",
  activityStatusList: "CreateActivity.StatusList",
  selectedDeliverables: "CreateActivity.SelectedDeliverables",
  selectApplicable: "CreateActivity.SelectApplicable",
  triggerBilling: "CreateActivity.TriggerBilling",
  countsTowardsLastContactDate: "CreateActivity.CountsTowardsLastContactDate",
  triggerTouchPointSurvey: "CreateActivity.TriggerTouchPointSurvey",
  waitActivityCreatingMessage: "CreateActivity.WaitActivityCreatingMessage",
  activityCreatedMessage: "CreateActivity.ActivityCreatedMessage",
  editActivityButton: "CreateActivity.EditActivityButton",
  viewActivityPopupTitle: "CreateActivity.ViewActivityPopupTitle",
  selectedOptionsText: "CreateActivity.SelectedOptionsText",
  editActivityPopupTitle: "CreateActivity.EditActivityPopupTitle",
  activityUpdatedMessage: "CreateActivity.ActivityUpdatedMessage",
  waitActivityUpdatingMessage: "CreateActivity.ActivityUpdatedWaitMessage",
  noTaggedDeliverablesTooltip:
    "CreateActivity.YouHaventTaggedAnyDeliverablesToThisActivityYetTooltipMessage",
  noDeliverablesAvailable: "CreateActivity.NoDeliverablesAvailableMessage",
  duplicateEntriesFoundInActivities:
    "CreateActivity.DuplicateEntriesFoundInActivities",

  halfDay: "DefaultActivityValues.HalfDay",
  units: "DefaultActivityValues.Units",
  defaultActivityKey: "DefaultActivityValues",
  unitLists: "DefaultActivityValues.UnitLists",
  minutesList: "DefaultActivityValues.MinutesList",
  minutes: "DefaultActivityValues.Minutes",
  quantity: "DefaultActivityValues.Quantity",
  numberofDays: "DefaultActivityValues.NumberofDays",
  country: "DefaultActivityValues.Country",
  measurement: "DefaultActivityValues.Measurement",
  addException: "DefaultActivityValues.AddException",
  exceptions: "DefaultActivityValues.Exceptions",
  defaultActivityCountry: "DefaultActivityValues.Country",
  action: "DefaultActivityValues.Action",
  deleteException: "DefaultActivityValues.DeleteException",

  createDeliverableKey: "ClientManagement.CreateClient.CreateDeliverable",
  editDeliverableNote: "CreateDeliverable.IsClientSpecificDeliverableNote",
  createDeliverableNote:
    "CreateDeliverable.WillBeClientSpecificDeliverableNote",
  createDeliverableUnitList: "CreateDeliverable.UnitsList",
  createDeliverableMinuteList: "CreateDeliverable.MinutesList",
  createDeliverablesMinutesLabel: "CreateDeliverable.Minutes",
  deliverableTypeList: "CreateDeliverable.DeliverableTypeList",
  addDeliverable: "CreateDeliverable.AddDeliverableHeading",
  selectType: "CreateDeliverable.SelectType",
  addNewDeliverable: "CreateDeliverable.AddNewDeliverableRadioButton",
  selectExistingDeliverables:
    "CreateDeliverable.SelectExistingDeliverablesRadioButton",
  deliverableType: "CreateDeliverable.DeliverableType",
  createDeliverableUnits: "CreateDeliverable.Units",
  deliverableName: "CreateDeliverable.DeliverableName",
  deliverableUpdatedMessage: "CreateDeliverable.DeliverableUpdatedMessage",
  deliverableAddedMessage: "CreateDeliverable.DeliverableAddedMessage",
  createDeliverableMinutes: "CreateDeliverable.Minutes",
  createDeliverableNumberOfDays: "CreateDeliverable.NumberOfDays",
  createDeliverableQuantity: "CreateDeliverable.Quantity",

  deliverablesListKey: "ClientManagement.CreateClient.DeliverablesList",
  addDeliverablesLabel: "DeliverablesList.AddDeliverablesLinkText",
  editDeliverableButtonText: "DeliverablesList.EditDeliverableButtonText",
  viewDeliverable: "DeliverablesList.ViewDeliverable",
  deliverableViewType: "DeliverablesList.DeliverableType",
  deliverablesViewName: "DeliverablesList.DeliverableName",
  deliverablesActivityType: "DeliverablesList.ActivityType",
  deliverablesUnits: "DeliverablesList.Units",
  deliverablesMeasurement: "DeliverablesList.Measurement",
  selectedActivities: "DeliverablesList.SelectedActivities",
  createDeliverableMeasurement: "CreateDeliverable.Measurement",
  existingDeliverables: "CreateDeliverable.ExistingDeliverablesHeading",
  deliverableSaveAlertMessage: "CreateDeliverable.DeliverableSaveAlertMessage",
  deleteDeliverableConfirmation: "DeliverablesList.DeleteDeliverableActionText",
  deletingDeliverable: "DeliverablesList.DeletingDeliverableText",
  deleteDeliverableSuccess: "DeliverablesList.DeleteDeliverableSuccessText",
  editDeliverableTitle: "DeliverablesList.EditDeliverableHeading",
  deliverableUpdated: "DeliverablesList.DeliverableUpdated",
  contains: "FilterBy.Contains",
  activityTabText: "ActivitiesList.ActivitiesTabText",
  deliverablesTabText: "ActivitiesList.DeliverablesTabText",
};

export const keyClientDetailsSiteCoreKeys = {
  keyClientDetailsHeader:
    "ClientManagement.CreateClientComponent.KeyClientDetails",
  clientCode: "ClientManagement.KeyClientDetails.ClientCode",
  parentClient: "ClientManagement.KeyClientDetails.ParentClient",
  removeParentClient:
    "ClientManagement.KeyClientDetails.RemoveParentClientLinkText",
  tagParentClient: "ClientManagement.KeyClientDetails.TagParentClientLinkText",
  parentClientTagged: "ClientManagement.KeyClientDetails.ParentClientTagged",
  waitParentClientTagging:
    "ClientManagement.KeyClientDetails.WaitParentClientTagging",
  removeParentClientConfirmationMessage:
    "ClientManagement.KeyClientDetails.RemoveParentClientConfirmationText",
  waitParentClientRemoving:
    "ClientManagement.KeyClientDetails.WaitParentClientRemoving",
  parentClientRemoved: "ClientManagement.KeyClientDetails.ParentClientRemoved",
  removeTheParentClientAsItsInheritedContactsAreCurrentlyUsed:
    "ClientManagement.KeyClientDetails.WarningYouCannotRemoveTheParentClientAsItsInheritedContactsAreCurrentlyUsed",
  removeTheParentClientAsAtleastOneContactIsRequired:
    "ClientManagement.KeyClientDetails.WarningYouCannotRemoveTheParentClientAsAtleastOneContactIsRequired",
  client: "ClientManagement.KeyClientDetails.Client",
};
